import { z } from 'zod';
import { BOM_ITEM_GROUP_CONSTRAINTS } from './constraints.js';
export const bomItemGroupNameSchema = z
    .string()
    .trim()
    .min(1, `${BOM_ITEM_GROUP_CONSTRAINTS.name.label} is required.`)
    .max(BOM_ITEM_GROUP_CONSTRAINTS.name.maxLength, `${BOM_ITEM_GROUP_CONSTRAINTS.name.label} must be ${BOM_ITEM_GROUP_CONSTRAINTS.name.maxLength} characters or fewer.`);
export const bomItemGroupPromptSchema = z
    .string()
    .trim()
    .min(1, `${BOM_ITEM_GROUP_CONSTRAINTS.prompt.label} is required.`)
    .max(BOM_ITEM_GROUP_CONSTRAINTS.prompt.maxLength, `${BOM_ITEM_GROUP_CONSTRAINTS.prompt.label} must be ${BOM_ITEM_GROUP_CONSTRAINTS.prompt.maxLength} characters or fewer.`);
// Shared by BomOptionGroupAddDialog (create) and BomOptionGroupEditDetailsDialog (edit) so neither re-derives these field rules.
export const bomItemGroupDetailsFormSchema = z.object({
    name: bomItemGroupNameSchema,
    prompt: bomItemGroupPromptSchema,
});
//# sourceMappingURL=item-group-form.js.map